/**
 * Created by Denis Kuzin on 29 march 2022
 */

const ClanInformationWindow = BaseClanWindow.extend({
    ctor: function (clan) {
        this.updateClan = clan;

        this._super(clan);
    },

    onWindowLoaded: function (clan) {
        this._super({
            clan,
            name: "ClanInformationWindow",
            title: clan.name
        });

        this.changeBanner(this.clan.emblem);
    },

    createContent: function () {
        const content = this._super();

        const tab = new ClansInfoTab({
            width: content.width,
            height: content.height
        }, this.clan);
        tab.setAnchorPoint(0.5, 0.5);
        tab.setAlignment(content.width / 2, content.height / 2);
        content.addChild(tab);

        return content;
    }
});
